import SSSlide from './00-slideshare_slide';

function SSPresentationSlide(config){
  SSSlide.call(this, config);
  this.PADDING = 0;
}

SSPresentationSlide.prototype = new SSSlide();

SSPresentationSlide.prototype.wrapperOffset = function(){
  return this.currentViewMode.wrapperWidth;
};

SSPresentationSlide.prototype.empty = function(){
  if (typeof this.currentViewMode.wrapper !== 'undefined'){
    this.currentViewMode.wrapper.empty();
  }
};

SSPresentationSlide.prototype.displayLoading = function(){
  var top, left;
  top = this.currentViewMode.height/2 - 16;
  left = this.currentViewMode.width/2 - 16;
  this.empty();
  this.spinnerUrl = (this.isFullscreen() ? this.config.spinnerUrlFullscreen : this.config.spinnerUrl);
  $('<img/>').attr({src: this.spinnerUrl}).css({
    width : 32,
    height : 32,
    top : top,
    left : left,
    position : 'absolute'
  }).appendTo(this.currentViewMode.wrapper);
};

// only container size. content should scale to fit
SSPresentationSlide.prototype.setDimensions = function(dimensions){
  // relaxedContent aspect is so images can be rendered in original dimensions 
  //   if height can be clipped off a few pixels
  var origwidth, origheight, contentAspect, relaxedContentAspect;
  var viewWidth = dimensions.parentWidth;
  var viewHeight = dimensions.parentHeight;
  var viewAspect = viewWidth/viewHeight;

  if (this.contentWidth === undefined || this.contentHeight === undefined){
    origwidth = viewWidth;
    origheight = viewHeight;
    contentAspect = viewAspect;
    relaxedContentAspect = contentAspect;
    $.slideshareEventManager.trackRawEvent('jsplayer_debug', 'no_content_meta_info', 'st_' + this.config.stripped_title);
  } else {
    origwidth = this.contentWidth;
    origheight = this.contentHeight;
    contentAspect = origwidth/origheight;
    relaxedContentAspect = origwidth/(origheight-20); // ignoring divide by zero possibility
  }

  var scale, contentScale, fontscale, width, height;
  var top, left;

  if (relaxedContentAspect>viewAspect ){
    //perform width based manipulations
    contentScale = viewWidth/origwidth;
    fontscale = contentScale*16;
    width = viewWidth;
    scale = viewAspect/contentAspect;
    left = 0;
    top = ((1-scale)/2*100) + '%';
    height = scale * dimensions.parentHeight;
  } else {
    contentScale = viewHeight/origheight;
    fontscale = contentScale*16;
    scale = contentAspect/viewAspect;
    top = 0;
    left = ((1-scale)/2*100) + '%' ;
    width = scale * dimensions.parentWidth;
    height = viewHeight;
  }

  width = parseInt(width, 10);
  height = parseInt(height, 10);

  var wrapperWidth = viewWidth;
  var wrapperHeight = viewHeight;

  this.currentViewMode.container.css({
    width : viewWidth,
    height : viewHeight
  });

  !this.config.show_image_player && this.currentViewMode.wrapper.css({
    width: width,
    height: height,
    top : top,
    left : left,
    position: 'absolute',
    padding : this.PADDING,
    overflow : 'hidden'
  });

  this.currentViewMode.wrapperWidth = wrapperWidth;
  this.currentViewMode.wrapperHeight = wrapperHeight;
  this.currentViewMode.top = top;
  this.currentViewMode.left = left;
  this.currentViewMode.contentScale = contentScale;
  this.currentViewMode.fontscale = fontscale;
  this.currentViewMode.width = width;
  this.currentViewMode.height = height;
};

SSPresentationSlide.prototype.hide = function(){
  if (!this.currentViewMode.rendered){
    return;
  }
  this.empty();
  delete(this.currentViewMode.contentElement);
  delete(this.currentViewMode.imageElement);
  this.currentViewMode.rendered = false;
};

SSPresentationSlide.prototype.show = function(force){
  if (this.currentViewMode.rendered && !force){
    return;
  }
  this.currentViewMode.rendered = true;
  this.load();
};

SSPresentationSlide.prototype.play = function(){
  // trigger current slide event
  this.show();
};

SSPresentationSlide.prototype.setContainer = function(config){
  var mode = config.mode;
  var currentViewMode = this.viewModes[mode];

  // The start slide is now embeded in the dom and rendered by default.
  var rendered = false;
  if (this.config.isStartSlide && this.config.show_image_player ) {
    rendered = true;
  }

  var viewMode = {
    'rendered' : rendered,
    'container' : config.container
  };

  if (currentViewMode === undefined ){
    if (!this.config.show_image_player){
      viewMode.wrapper = $('<div/>').appendTo(config.container);
    }
    currentViewMode = viewMode;
  } else if (mode == "nativefullscreen"){
    if (!this.config.show_image_player){
      viewMode.wrapper = this.currentViewMode.wrapper;
    }
    currentViewMode = viewMode;
  }

  if (!this.config.show_image_player){
    currentViewMode.container.removeClass();
    var containerClass = config.bgColor || 'jsplBgColorBigfoot';
    if(typeof new_mobile_player === 'undefined'){
     containerClass += ' horizontalStack';
    } else {
      containerClass += ' verticalStack';
    }
    currentViewMode.container.addClass(containerClass);
  }
  var slideNumber = config.slideNumber;
  if(slideNumber){
    currentViewMode.container.attr('slideNumber', slideNumber);
  }

  this.viewModes[mode] = currentViewMode;

  this.currentViewMode = currentViewMode;
  this.currentMode = config.mode;
};

export default SSPresentationSlide;